import React from 'react';

const DiligenceSection = () => {
  return (
    <section id="diligence">
      <div className="container">
        <div className="section-label">06 — Diligence</div>
        <div className="diligence-grid">
          <div className="diligence-text reveal">
            <h3>Diligence Statement</h3>
            <p>
              In creating this portfolio, I collaborated with Claude (Anthropic) to assist with design and layout decisions, as well as determining which sections would best represent my work and experience to potential employers.
            </p>
            <p>
              I affirm that all AI-assisted content underwent thorough personal review and evaluation before publishing. The final portfolio accurately reflects my own professional background, skills, projects, and intended presentation. While Claude's assistance was instrumental in shaping the structure and visual design, I maintain full responsibility for the content, its accuracy, and how it represents me professionally.
            </p>
            <p>
              This disclosure is made in the spirit of transparency and to acknowledge the role of AI in the creation process.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DiligenceSection;
